import { u as useConfigContext, g as useHandleProductClickCapture, R as React, c as clsx, h as PriceDisplay, Q as QuickShop, f as useProductsContext, r as reactExports, P as ProductCardFull, b as createRoot, L as Loop54Provider } from './product-card-full-DSYtTZt2.js';
import './api-CpztVm6z.js';
import './js.cookie-D5Tj-jx_.js';
import './facets-KV1fKOgI.js';
import { C as Carousel } from './carousel-C0RXU3sw.js';
import './currency-CKawTtqN.js';
import './autoplay-B8ZNRkpc.js';

function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }
const ProductCardCondensedRow = ({ selected = false, product, isAutocompleteResult }) => {
  const { productPlaceholderImageSrc } = useConfigContext();
  const {
    id,
    url,
    image: productImage,
    title: productTitle,
    lowestVariantPrice = 0,
    lowestVariantCompareAtPrice,
    employeePrice,
    samePriceAllVariants,
    sameCompareAtPriceAllVariants,
  } = product || {};

  const handleProductClick = useHandleProductClickCapture({ type: 'click', id: _nullishCoalesce(id, () => ( '')), url: _nullishCoalesce(url, () => ( '')) });

  const image = productImage || productPlaceholderImageSrc;
  const title = productTitle || 'Placeholder title';
  const ImageWrapper = selected ? 'div' : 'a';
  const TitleWrapper = selected ? 'p' : 'a';
  const linkProps = selected ? {} : { href: url, title };

  return (
    React.createElement('div', { className: "grid w-full grid-cols-[max-content,1fr,max-content] items-center gap-element-spacing"    , onClickCapture: handleProductClick,}
      , React.createElement(ImageWrapper, { ...linkProps, className: "w-[75px]",}
        , React.createElement('img', {
          src: `${image}&width=100`,
          alt: title,
          width: "100",
          height: "100",
          loading: "lazy",
          className: clsx('full aspect-square bg-gray-200'),
          title: title,
          'data-custom-aspect-ratio': "true",}
        )
      )
      , React.createElement('div', { className: clsx('flex flex-col gap-2'),}
        , React.createElement(TitleWrapper, { ...linkProps, className: "my-0 text-sm leading-[1.125rem] text-black states:text-primary states:no-underline"     ,}
          , title
        )
        , React.createElement(PriceDisplay, {
          price: lowestVariantPrice,
          comparePrice: lowestVariantCompareAtPrice,
          employeePrice: employeePrice,
          samePriceAllVariants: _nullishCoalesce(samePriceAllVariants, () => ( true)),
          sameCompareAtPriceAllVariants: _nullishCoalesce(sameCompareAtPriceAllVariants, () => ( true)),}
        )
      )
      , React.createElement(QuickShop, { product: product, className: "self-end",} )
    )
  );
};

function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }

 




const ComplimentaryProducts = ({ productId, title, layout = 'carousel', take = 3 }) => {
  const productsContext = useProductsContext();

  if (!productsContext) return;

  const { fetchRecommendations, products, isLoading } = productsContext;

  reactExports.useEffect(() => {
    if (!fetchRecommendations) return;

    const entity = {
      type: 'Product',
      id: productId,
    };

    fetchRecommendations({ api: 'getComplementaryEntities', apiArgs: [entity], take });
  }, []);

  const filteredProducts = _optionalChain([products, 'optionalAccess', _ => _.filter, 'call', _2 => _2((product) => product.isAvailable)]);

  if (!_optionalChain([filteredProducts, 'optionalAccess', _3 => _3.length])) return null;

  if (layout === 'list') {
    return (
      React.createElement('div', { className: "cart-notification-related",}
        , React.createElement('p', { className: "cart-notification__heading my-0 border-t border-gray-400 pt-4 text-base font-medium leading-5 md:text-lg md:leading-6"         ,}
          , title
        )
        , React.createElement('div', { className: "flex flex-col items-start gap-6 pb-4 pt-4 text-sm leading-5"       ,}
          , filteredProducts.map((product, index) => (
            React.createElement(ProductCardCondensedRow, { key: product.id, index: index, product: product,} )
          ))
        )
      )
    );
  }

  return (
    React.createElement(Carousel, {
      title: title,
      slides: filteredProducts.map((product, index) => () => React.createElement(ProductCardFull, { index: index, key: product.id, product: product,} )),}
    )
  );
};

let root;

const WithLoop54 = (props) => {
  return (
    React.createElement(Loop54Provider, { isIsland: true,}
      , React.createElement(ComplimentaryProducts, { ...props,} )
    )
  );
};

const render = (props) => {
  if (!props.productId || !props.id) return;

  const rootNode = document.getElementById(props.id) ;

  root = createRoot(rootNode);

  root.render(React.createElement(WithLoop54, { ...props,} ));
};

const unmount = () => {
  if (!root) return;

  root.unmount();
};

export { render, unmount };
